/* eslint-disable no-param-reassign */
import m from "mithril";
import moment from "moment";
import header from "../../components/header";
import toolbar from "../../components/toolbar"
import sidebar from "../../components/sidebar"
import table_data from "../../components/table_data"
import graph from "./components/graph";
import multiSelect from "../../components/bootstrap-select";
import companyBannner from "../../components/companyBannner";
import { runQuery, headers } from "../../utils/fetchData";
import timePicker from "../../components/timePicker";
import htmlEditor from "../../components/htmlEditor";
import config from "../../config";
import stats from "./components/stats";
import map from "./components/google-maps";
import tmpMap from "./components/tmpMap";
import tutorials from "./components/tutorials";
import commonQuestions from "./components/commonQuestions";
import dataMap from "../../utils/data";

import { t } from '../../translation-files/translator'

import addTutorials from "./modals/add"


function getNumberWithOrdinal(i) {
  const j = i % 10;

  const k = i % 100;
  if (j === 1 && k !== 11) {
    return `${i}st`;
  }
  if (j === 2 && k !== 12) {
    return `${i}nd`;
  }
  if (j === 3 && k !== 13) {
    return "rd";
  }
  return `${i}th`;
}

export default {
  async oninit({ state, attrs }) {
    Object.assign(state, {
      selectedTeams: [],
      selectedUsers: [],
      selectedProjects: [],
      teams: [],
      users: [],
      projects: [],
      projectsT: true,
      teamsT: false,
      usersT: false,
      fetching: false,
      selectedTime: {
        end: moment(new Date()),
        start: moment(new Date())
          .subtract(6, "day")
          .startOf("day")
      },
      data: [],
      labels: [],
      stats: {},
      gpsData: []
    });

    state.fetchResults = async clientId => {
      const { start, end } = state.selectedTime;

      state.fetching = true;
      m.redraw();

      try {
        const results = await m.request({
          method: "POST",
          headers: headers(),
          url: `${config[window.env].apiUrl}/submision/breakDayDown/${new Date(
            start
          ).toISOString()}/${new Date(end).toISOString()}`,
          data: Object.assign(
            {
              client: clientId
            },
            state.teamsT === true
              ? { teamId: { $in: state.selectedTeams } }
              : {},
            state.projectsT === true
              ? { projectId: { $in: state.selectedProjects } }
              : {},
            state.usersT === true
              ? { userId: { $in: state.selectedUsers } }
              : {}
          )
        });

        Object.assign(state, {
          fetching: false,
          data: [],
          labels: []
        });
        m.redraw();

        const labels = Object.values(results)
          .reverse()
          .map(
            ({ start }) =>
              `${getNumberWithOrdinal(moment(start).format("DD"))}-${moment(
                start
              ).format("MM")}`
          );

        const data = Object.values(results)
          .reverse()
          .map(({ count }) => count);

        const gpsData = Object.values(results)
          .reverse()
          .map(({ data }) => data);

        Object.assign(state, {
          data,
          labels,
          gpsData
        });

        m.redraw();
      } catch (err) {
        Object.assign(state, {
          fetching: false
        });
        m.redraw();
      }
    };

    state.resetSelections = () => {
      Object.assign(state, {
        selectedTeams: [],
        selectedUsers: [],
        selectedProjects: [],
        teams: [],
        users: [],
        projects: [],
        projectsT: true,
        teamsT: false,
        usersT: false,
        selectedTime: {
          end: moment(new Date()),
          start: moment(new Date())
            .subtract(6, "day")
            .startOf("day")
        },
        fetching: false,
        data: [],
        labels: []
      });

      m.redraw();
    };

    const {
      users,
      id: clientId,
      stats,
      teams,
      projects
    } = await dataMap.getClientData();

    Object.assign(state, {
      projects,
      teams,
      users,
      stats,
      clientId,
      selectedTeams: [...teams.map(p => p.id)],
      selectedUsers: [...users.map(p => p.id)],
      selectedProjects: [...projects.map(p => p.id)]
    });

    state.fetchResults(clientId);
    m.redraw();
  },
  // disable due to failures on some browsers
  oncreate() {
    //   const urlParams = new URLSearchParams(window.location.search);
    //   const accType = urlParams.get('u');
    //   if (accType === 'new')
    //     introJs().start();
  },
  view({ state, attrs }) {
    console.log({ t: t() })
    return [
      // <!--begin::Header-->
      m(addTutorials),
      m(header, {
        logos: {
          dark: "assets/media/logos/bill-logo.svg",
          light: "assets/media/logos/bill-logo.svg"
        },
        links: [{
          label: t().home_acc_info.navbar.reports,
          route: "/reports",
        }, {
          label: t().home_acc_info.navbar.user_management,
          route: "/userManagement"
        }, {
          label: t().home_acc_info.navbar.support,
          route: "/support",
          routesToActivate:["/support","/tutorials"]
        }, {
          label: t().home_acc_info.navbar.notifications,
          route: "/notifications",
          routesToActivate:["/notifications","/notifications/triggers"]
        }, {
          label: t().home_acc_info.navbar.trends,
          route: "/trends-disabled"
        }]
      }),
      // <!--end::Header-->

      // <!--begin::Wrapper-->
      m("div", { "class": "app-wrapper flex-column flex-row-fluid", "id": "kt_app_wrapper" }, [
        // <!--begin::Main-->
        m("div", { "class": "app-main flex-column flex-row-fluid", "id": "kt_app_main" }, [
          // <!--begin::Content wrapper-->
          m("div", { "class": "d-flex flex-column flex-column-fluid" }, [
            // <!--begin::Toolbar-->
            m(toolbar, {
              header: {
                label: "XYZ Transporters",
                subLabel: [t().common.account_type, t().common.post_paid]
              },
              toolBarItems: [{
                label: t().home_acc_info.subheader_labels.dashboard,
                route: "/dashboard",
                routesToActivate:["/dashboard"]
              }, {
                label: t().home_acc_info.subheader_labels.home,
                route: "/",
                routesToActivate:["/","/stationFinder","/journeyPlan"]
              }, {
                label: t().home_acc_info.subheader_labels.cards,
                route: "/cardList",
                routesToActivate:["/cardList","/departments","/drivers"]
              }, {
                label: t().home_acc_info.subheader_labels.transactions,
                route: "/transactions",
                routesToActivate:["/transactions"]
              }, {
                label: t().home_acc_info.subheader_labels.funds,
                route: "/funds",
                routesToActivate:["/funds","/cardToCard"]
              }]
            }),
            // <!--end::Toolbar-->

            // <!--begin::Content-->
            m("div", { "class": "app-container container-xxl", "id": "kt_app_content_container" }, [
              // <!--begin::Inbox App - Messages -->
              m("div", { "class": "d-flex flex-column flex-lg-row" }, [
                // <!--begin::Sidebar-->
                m(sidebar, {
                  sideBarItems: [{
                    label: t().notifications.sidebar_labels.alerts,
                    icon: "bi bi-bell",
                    route: "/notifications"
                  },
                  {
                    label: t().notifications.sidebar_labels.triggers,
                    icon: "bi bi-clock-history",
                    route: "/notifications/triggers"
                  }]
                }),
                // <!--end::Sidebar-->
                // <!--begin::Content-->
                m("div", { "class": "app-content ", "id": "kt_app_content", style: {
                  "flex-grow": 1,
                  "flex-basis": "auto",
                } },
                  m("div", { "class": "app-container container-xxl", "id": "kt_app_content_container" },
                    [
                      m(table_data, {
                        title: t().notifications.title,
                        actionItems: [
                          m("div", { "class": "d-flex justify-content-end", "data-kt-customer-table-toolbar": "base", style:{ "padding-right":"10px"} },
                            [
                              m("button", { "class": "btn btn-primary", "type": "button", "data-bs-toggle": "modal", "data-bs-target": "#kt_modal_add_customer" },
                                t().notifications.toolbar_actions.advanced_search
                              )
                            ]
                          ),
                          m("div", { "class": "d-flex justify-content-end", "data-kt-customer-table-toolbar": "base" },
                            [
                              m("button", { "class": "btn btn-primary", onclick: () => {} },
                                t().notifications.toolbar_actions.new_alert
                              )
                            ]
                          ),
                        ],
                        dataConfigs: {
                          sourceEndpoint: "/alerts",
                          dataMapping: [{
                            label: t().notifications.triggers_list.header.description,
                            data_key: "description"
                          }, {
                            label: t().notifications.triggers_list.header.value,
                            data_key: "value"
                          }, {
                            label: t().notifications.triggers_list.header.unit,
                            data_key: "unit"
                          }, {
                            label: t().notifications.triggers_list.header.num_alerts,
                            data_key: "num_alerts"
                          }, {
                            label: t().notifications.triggers_list.header.latest_alert,
                            data_key: "latest_alert"
                          }],
                          dataRows: Array.from({ length: 25 }, () => ({
                            description: `Card balance threshold`,
                            value: Math.floor(Math.random() * 10000), // random numeric value
                            unit: [Math.random() < 0.5 ? "KSH" : "USD"],
                            num_alerts: Math.floor(Math.random() * 10), // random number of alerts
                            latest_alert: new Date(Date.now() - Math.random() * 31536000000)
                          }))
                        }
                      })
                    ]
                  )
                )
                // <!--end::Content-->
              ])
              // <!--end::Inbox App - Messages -->
            ])
            // <!--end::Content-->
          ])
        ])
      ])

    ];
  }
};
